import { isRejected } from '@reduxjs/toolkit';
import {
    selectedItemsCountSelector,
    submitErrorSelector,
    submitOfferThunk,
    submitStatusSelector, submitWarningSelector
} from 'pages/candidateOffer/store';
import { addProcessedOfferByToken } from 'pages/candidateOfferList/store';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch, useGoBackToOpportunities } from 'shared/hooks';

import { Offer } from '../../candidateOffer/types';
import { ListOffer } from '../types';

export default function useAcceptOfferDialogState(offer: ListOffer | Offer) {
    const dispatch = useAppDispatch();

    const selectedItemsCount = useSelector(selectedItemsCountSelector);
    const error = useSelector(submitErrorSelector);
    const warning = useSelector(submitWarningSelector);
    const submitStatus = useSelector(submitStatusSelector);

    const [ dialogOpen, setDialogOpen ] = useState<boolean>(false);

    const goBack = useGoBackToOpportunities();

    const openDialog = useCallback(() => {
        setDialogOpen(true);
    }, [ ]);

    const closeDialog = useCallback(() => {
        setDialogOpen(false);
    }, [ ]);

    const handleSubmitClick = useCallback(() => {
        dispatch(submitOfferThunk()).then((submitResult) => {
            if (isRejected(submitResult) || !offer) {
                return;
            }

            dispatch(addProcessedOfferByToken({ offer, offerStatus: 'applied' }));

            closeDialog();

            if (goBack) {
                goBack();
            }
        });
    }, [ dispatch, goBack, closeDialog, offer ]);

    return {
        dialogState: {
            closeDialog,
            onConfirm: handleSubmitClick,
            error: error ?? warning,
            submitting: submitStatus === 'pending',
            selectedItemsCount,
            open: dialogOpen
        },
        openDialog
    };
}
